import {
  isLocalhost,
  isProduction,
  isStorybook,
  isTest,
} from '../capabilities/environment/get-environment';
import warn from '../capabilities/warn';

/**
 * Check to see if the inventory service needs to be run
 *
 * @returns void
 */
const checkInventory = () => {
  // never do inventory in production environments
  if (isProduction(document.location)) {
    return;
  }

  if (isTest(document)) {
    return;
  }

  const file = 'hp6-web-component-library/src/global/index.ts';

  // never do inventory on storybook pages
  if (isStorybook(document.location)) {
    warn(
      `${file} checkInventory(): inventory will not be run for Storybook pages`,
    );
    return;
  }

  // Only load the inventory module if it is allowed in that environment
  if (isLocalhost(document.location)) {
    // eslint-disable-next-line no-console
    console.info(
      `${file} checkInventory(): inventory will not be run on localhost`,
    );
    return;
  }

  import('./inventory').then(inventory => {
    inventory.default();
  });
};

/**
 * Call this function on every page where hp-web-component-library is used
 */
const globalScript = () => {
  window.addEventListener('DOMContentLoaded', checkInventory);
};

export default globalScript;
